import { ContextService } from '../../services/context_service';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungJahrauswahlEinzeln } from './DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { getStandorte } from '../../helpers/getStandorte';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StandortAuswahl } from './elements/StandortAuswahl';
import style from './datenauswertung.less'
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface EnergieCockpitAuswahlProps extends React.ClassAttributes<any> {
    data: any;
    jahr: number;
    onJahrChange: (jahr: number) => void;
    onPdfCreate: () => void;
    onRoutingChange: (routing: any) => void;
    onStandortChange: (standort: number) => void;
    standort: number;
}

interface EnergieCockpitAuswahlState {
    hasCo2Fussabdruck: boolean;
    jahrMin: number;
    jahrMax: number;
    tabStandort: number;
}

export class EnergieCockpitAuswahl extends React.Component<EnergieCockpitAuswahlProps, EnergieCockpitAuswahlState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            hasCo2Fussabdruck: false,
            jahrMin,
            jahrMax,
            tabStandort: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.setTab();
    }

    componentDidUpdate(prevProps: any): void {
        this.setTab();
    }

    render(): JSX.Element {
        const arr_header_form_elements: any[] = [
            { elem: this.renderJahr(), wrapClass: 'datenauswertungContentLeft' },
            { elem: this.renderStandort(), wrapClass: 'datenauswertungContentGrow' },
            { elem: <span className={style.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            this.state.hasCo2Fussabdruck && { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderCo2Button()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <>
                    {!this.state.hasCo2Fussabdruck ? <label style={{ marginRight: -31 }}>{i18n('Optionen', 'sys')}</label> : <label>&nbsp;</label>}
                    {this.renderBemerkungButton()}
                </>,
                wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderReportExportButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderPdfButton()}</>, wrapClass: 'datenauswertungContentRight' },
            // { elem: <><label>&nbsp;</label>{this.renderHelpIcon2()}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                <DatenauswertungFormWrapper
                    elements={arr_header_form_elements}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                noLabel
                standort={this.props.standort}
                styleProps={{ color: 'white', backgroundColor: '#686868' }}
                type='energiecockpit'
            />
        );
    }

    renderCo2Button(): JSX.Element {
        const data: any = this.props.data || {};
        const hasVeranstaltungen: boolean = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
        const indexStandorte: number = ((getStandorte(data) || []).length > 1 || hasVeranstaltungen) ? 1 : 2;

        return (
            <WActionButton
                styleProps={{ padding: '1px 8px', whiteSpace: 'nowrap' }}
                label={i18n('CO₂-Fußabdruck Auswertung', 'sys')}
                insideText={i18n('CO₂-Fußabdruck Auswertung', 'sys')}
                key='co2'
                action='gotoAuswertung'
                onAction={() => {
                    this.contextService.set('jahr_cockpit', this.props.jahr);
                    this.props.onRoutingChange({
                        path: {
                            ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
                            [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: indexStandorte,
                            [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: 0,
                            terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
                        },
                        // path: {
                        //     ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
                        //     [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: this.state.tabStandort
                        // },
                        jahr: this.props.jahr
                    });
                }}
            />
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginRight: 5, display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={i18n('Energie Cockpit - Auswahl', 'sys')}
                helpKey='energie_cockpit_auswahl'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderHelpIcon2(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginLeft: 5, display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={i18n('Report / Export generieren', 'sys')}
                helpKey='report_export_generieren'
                type='theme_info'
                style='theme'
                editBar
                useTheme
            />
        );
    }

    renderJahr(): JSX.Element {
        return (
            <DatenauswertungJahrauswahlEinzeln
                jahrMin={this.state.jahrMin}
                jahrMax={this.state.jahrMax}
                jahr={this.props.jahr}
                onJahrChange={(jahr: number) => this.props.onJahrChange(+jahr)}
                renderClean
            />
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                styleProps={{ color: 'white', backgroundColor: '#686868', marginLeft: 10, padding: '1px 8px', whiteSpace: 'nowrap' }}
                label={i18n('Cockpit drucken (pdf)', 'sys')}
                // insideText='Cockpit drucken (pdf)'
                tooltip={i18n('Cockpit drucken (pdf)', 'sys')}
                key='pdf'
                action='print'
                onAction={() => this.props.onPdfCreate()}
            />
        );
    }

    renderReportExportButton(): JSX.Element {
        return (
            <WActionButton
                styleProps={{ color: 'white', backgroundColor: '#686868'/*, marginLeft: 10*/, padding: '1px 8px', whiteSpace: 'nowrap' }}
                label={i18n('Report / Export generieren', 'sys')}
                // insideText={i18n('Report / Export generieren', 'sys')}
                tooltip={i18n('Zum Report-/ Exportbereich springen', 'sys')}
                key='report_export'
                action='export'
                onAction={() => this.props.onRoutingChange({ path: RoutingIDs.ROUTE_ZUSATZTOOLS_REPORT_EXPORT })}
            />
        );
    }

    renderStandort(): JSX.Element {
        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standort}
                onStandortChange={(standort: number) => this.props.onStandortChange(standort)}
                renderClean
            />
        );
    }

    setTab(): void {
        const data: any = this.props.data || {};
        const standorte: any[] = getStandorte(data) || [];
        const index: number = standorte.findIndex((standort: any) => standort.tid === this.props.standort || null);
        const kennzahlen: any = (this.props.standort
            ? (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[this.props.standort] || {}
            : data[IDs.KENNZIFFERN_BERECHNET] || {}
        ).flags || {};
        // this.setState({
        //     hasCo2Fussabdruck: kennzahlen.hasCO2,
        //     tabStandort: index === -1 ? 1 : index + (standorte.length > 1 ? 2 : 1)
        // });
        const hasCo2Fussabdruck = kennzahlen.hasCO2;
        if (this.state.hasCo2Fussabdruck !== hasCo2Fussabdruck) {
            this.setState({ hasCo2Fussabdruck });
        }
        const tabStandort = index === -1 ? 1 : index + (standorte.length > 1 ? 2 : 1);
        if (this.state.tabStandort !== tabStandort) {
            this.setState({ tabStandort });
        }
    }
}
